module.exports = __webpack_public_path__ + "img/abdul-kalam-sir.e5129c4c.png";